<template>
  <div class="container">
    <el-row class="content-row">
      <el-col :span="2" class="left-col">
        <el-menu
          class="menu-container"
          :default-active="$route.path"
          :router = "true">
          <!--  管理人员的菜单数据管理 -->
          <el-menu-item index="/uncollectedOrder" class="menu-item"> 未领订单</el-menu-item>
          <el-menu-item index="/receiveOrder" class="menu-item"> 已领订单</el-menu-item>
          <el-menu-item index="/createOrder" class="menu-item"> 创建订单</el-menu-item>
          <el-menu-item index="/newOrderList" class="menu-item">查看正式订单 </el-menu-item>
          <!-- createOrder-->
        </el-menu>
      </el-col>
      <el-col :span="22" class="right-col">
        <header-top></header-top>
        <breadcrumb></breadcrumb>
        <!-- <keep-alive> -->
          <router-view key="$route.fullpath"></router-view>
        <!-- </keep-alive> -->
      </el-col>
    </el-row>
  </div>
</template>

<script type='text/ecmascript-6'>
import { getStore } from 'common/js/mUtils'
import HeaderTop from 'components/headerTop.vue'
import Breadcrumb from 'components/Breadcrumb.vue'
export default {
  data () {
    return {
      type: 1
    }
  },
  computed: {
    defaultActive () {
      return '/' + this.$route.path.split('/').reverse()[0]
    }
  },
  created () {
    this.type = getStore('user_type')
  },
  methods: {
  },
  watch: {
    type (newVal) {
      this.type = newVal
    }
  },
  components: {
    Breadcrumb,
    HeaderTop
  }
}
</script>

<style  scope lang='stylus' rel='stylesheet/stylus'>
  .container
    height:100%;
    .content-row
      height:100%;
      display: flex;
      .left-col
        min-height: 100%;
        min-width:6rem;
        background-color:#1A1B21;
        .menu-container
          min-height: 100%;
          background-color:#1A1B21;
          .menu-item
            color:#fff;
            font-size:0.7rem;
            cursor:pointer;
            &:hover
              background:#1D489E;
            &.is-active
              background-color:#1D489E;
              .el-icon
                color:#20a0ff;
            .el-icon
              color:#fff;;
              margin-right:0.5rem;
              vertical-align:middle;
            .img-icon
              margin-right:0.5rem;
          .menu-list
            .el-submenu__title
              color:#fff;
              font-size:0.7rem;
              cursor:pointer;
              &:hover
                background:#1D489E;
              &.is-active
                color:#fff;
                .el-icon
                  color:#20a0ff;
              .el-icon
                color:#fff;;
                margin-right:0.5rem;
                vertical-align:middle;
              .img-icon
                margin-right:0.5rem;
              .el-submenu__icon-arrow
                color:#fff;
          .el-menu
            width:100%;
            background-color: #1A1B21;
            .menu-item
              color:#fff;
              font-size:0.7rem;
              cursor:pointer;
              padding: 0 ;
              width:100%;
              &:hover
                background:#1D489E;
              &.is-active
                color:#fff;
                .el-icon
                  color:#20a0ff;
              .el-icon
                color:#fff;;
                margin-right:0.5rem;
                vertical-align:middle;
      .right-col
        min-height:100%;
        flex: 1;
        background:#f8fafb;
        position: relative;
        display: flex;
        flex-direction: column;
        /* overflow-y: auto; */
</style>

